/**
 * @atlas
 * @kind helper
 * @partOf primitive:shared, primitive:websockets
 * @uses none
 */
export type ChannelKeyInput = { _id: string; path?: Record<string, unknown> | null; brandUuid?: string | null };

const TENANCY_PARAM = 'brandUuid';

// gloss
export const channelKey = ({ _id, path, brandUuid }: ChannelKeyInput): string => {
  const idParts = Object.entries(path ?? {})
    .sort(([a], [b]) => a.localeCompare(b))
    .flatMap(([field, value]) => [field, String(value)]);
  const base = [_id, ...idParts].join(':');
  return brandUuid ? `${base}?${new URLSearchParams({ [TENANCY_PARAM]: brandUuid })}` : base;
};

// gloss
export const parseChannelKey = (channel: string): ChannelKeyInput => {
  const queryAt = channel.indexOf('?');
  const base = queryAt === -1 ? channel : channel.slice(0, queryAt);
  const brandUuid = queryAt === -1 ? null : new URLSearchParams(channel.slice(queryAt + 1)).get(TENANCY_PARAM);
  const [_id = '', ...parts] = base.split(':');
  const path: Record<string, string> = {};
  for (let i = 0; i + 1 < parts.length; i += 2) path[parts[i] as string] = parts[i + 1] as string;
  return {
    _id,
    ...(parts.length > 0 && { path }),
    ...(brandUuid && { brandUuid }),
  };
};
